import { FormEditor } from './../../models/editors/form-editor.base.model';

export class ContainedFormFields extends FormEditor<string> {
  controlType = 'containedFormFields';
  apiUrl: string;
  constructor(options: {} = {}) {
    super(options);
    this.apiUrl = options['apiUrl'] || '';
  }
}
